import React, { Component } from "react";
import { withSnackbar } from "notistack";
import { Grid } from "@material-ui/core";
import AdSearchBar from "../components/AdSearchBar";
import AdTable from "../components/AdTable";
import AdList from "../components/AdList";
import { getAdDataApi, UpdateAdTaskFormApi, uploadAdFileApi, importAdFileApi, exportAdAssetDetailListApi, deleteAdAssetDetailRow, fillAdEditFormApi, DownloadAllApi, exportMasterApi, bulkDelete, onArchiveAsset } from "../apiService";
import { assetFilterOps, smbceHead } from "./AdTableHead";
import { convertFilterObject, removeEmptyKey, permissionCheckFnforCamo } from "../../../../utils";
import { EmptyCollection, PageLoader, AccessDenied, DeletePopUp, } from "../../../../shared_elements";
import BasicDetailHeader from "../../BasicDetailHeader";
import { trackActivity } from '../../../../utils/mixpanel';
import SubDetails from "../../../../shared_elements/components/sub_details/SubDetails";
class ADComponent extends Component {
	constructor(props) {
		super(props);
		this.state = {
			addFormDialog: false,
			sidebarOpen: true,
			tabIndex: 0,
			pageLoader: false,
			sort: "",
			sort_by: "",
			assetsDetail: {
				list: [],
				pagination: {},
				asset_count: {},
				new_task_last_used_folder_uuid: '',
				last_used_folder_uuid_link_document: "",
				checkbox_last_used_folder_uuid: "",
				checkbox_last_used_folder_name: ""
			},
			headerData: {},
			searchData: "",
			headerTsn: "",
			headerCsn: "",
			currentRecordPerPage: 250,
			uuid: '',
			slug: '',
			basicDetails: {},
			isBasicDetailExpanded: true,
			bulkOperation: { modal: false, ids: [], title: '', type: '' },
			archiveModal: false
		};

		this.getAdDataApi = getAdDataApi.bind(this);
		this.toggleSidebar = this.toggleSidebar.bind(this);

		this.openAddForm = this.openAddForm.bind(this);
		this.closeAddForm = this.closeAddForm.bind(this);
		this.toggleSidebar = this.toggleSidebar.bind(this);
		this.handleDeleteRow = deleteAdAssetDetailRow.bind(this);
		this.handleEditRow = fillAdEditFormApi.bind(this);
		// this.getAircraftDetailApi = getAircraftDetailApi.bind(this);
		this.UpdateAdTaskFormApi = UpdateAdTaskFormApi.bind(this);
		this.uploadAdFileApi = uploadAdFileApi.bind(this);
		this.importAdFileApi = importAdFileApi.bind(this);
		this.downloadAllApi = DownloadAllApi.bind(this);
		this.exportAdAssetDetailListApi = exportAdAssetDetailListApi.bind(this);
		this.exportMasterApi = exportMasterApi.bind(this);
		this.bulkDelete = bulkDelete.bind(this);
		this.onArchiveAsset = onArchiveAsset.bind(this);
	}

	componentDidMount() {
		this.getData(null);
		this.pullData();
		trackActivity('AD Status Page Visited - CAMO', {
			event_type: 'Page Visited',
			page_title: 'Airworthiness Directives(ADs)',
		})
	}
	uuidData = (uuid) => {
		this.setState({ uuid: uuid });
	}
	pullData = (slug, tsn, csn,) => {
		this.setState({ slug: slug });
		this.setState({ headerTsn: tsn });
		this.setState({ headerCsn: csn });
	};
	getData(item) {
		this.getAdDataApi({ per_page: this.state.currentRecordPerPage }, "skeletonLoader", this.props, item ? item : null);
	}
	// mainHeaderData = () => {
	// 	getAircraftDetailApi().then((response) => {
	// 		const data = response.data.data;
	// 		this.setState({ headerData: data });
	// 	});
	// };
	openAddForm() {
		this.setState({ addFormDialog: true });
	}
	closeAddForm() {
		this.setState({ addFormDialog: false });
	}

	toggleSidebar() {
		this.setState({ sidebarOpen: !this.state.sidebarOpen });
	}

	createSortHandler = (sortField) => {
		const { sort, sort_by, filter, tabIndex, assetsDetail } = this.state;
		this.setState({ sort: sortField, sort_by: sortField === sort ? (sort_by === "asc" ? "desc" : "asc") : "desc", })
		if (sortField === sort) {
			if (sort_by === "asc") {
				this.getAdDataApi({ ...filter, sort: sortField, sort_by: "desc", per_page: assetsDetail.pagination.per_page, asset_type: tabIndex, }, "pageLoader", this.props);
			} else {
				this.getAdDataApi({ ...filter, sort: sortField, sort_by: "asc", per_page: assetsDetail.pagination.per_page, asset_type: tabIndex, }, "pageLoader", this.props);
			}
		} else {
			this.getAdDataApi({ ...filter, sort: sortField, sort_by: "asc", per_page: assetsDetail.pagination.per_page, asset_type: tabIndex, }, "pageLoader", this.props);
		}
	};

	submitFilter = (filterOptions) => {
		const { tabIndex, applyingFilter } = this.state;
		this.getAdDataApi({ ...convertFilterObject(removeEmptyKey(applyingFilter), filterOptions), asset_type: tabIndex, }, "pageLoader", this.props);
	};

	searchResults = (item) => {
		if (item !== null) {
			this.getData(item);
		}
	};

	updateFormData = async (updateId, updatedData, props, close, formClose) => {
		await this.UpdateAdTaskFormApi(updateId, updatedData, props, this.state.currentRecordPerPage, close, formClose);
	};

	fileUploadData = async (uploadId, formdata, props, haveAttachments) => {
		await this.uploadAdFileApi(uploadId, formdata, props, this.state.currentRecordPerPage, haveAttachments);
	};

	importFile = (formData, props, isXLSX) => {
		this.importAdFileApi(formData, props, isXLSX, this.state.currentRecordPerPage);
	};

	exportAssetDetailListFunc = (props) => {
		const { basicDetails } = this.state;
		this.exportAdAssetDetailListApi(props, '', this.props, basicDetails);
	};

	downloadAllFilesApi = (props) => {
		this.downloadAllApi(props);
	};

	refreshComp = () => {
		this.getData();
	};
	toggleBulkOps = async (flag, type, item) => {
		const { bulkOperation, assetsDetail } = this.state;
		try {
			if (type === 'bulk') {
				const response = await this.getAdDataApi(
					{ per_page: flag ? assetsDetail?.pagination?.total : this.state.currentRecordPerPage },
					"skeletonLoader",
					this.props,
					null
				);
				this.setState({
					bulkOperation: { ...bulkOperation, type: 'bulk', ids: flag ? response?.data?.results : [] }
				});
			} else {
				this.setState({
					bulkOperation: {
						...bulkOperation,
						type: 'single',
						ids: flag ? [...bulkOperation.ids, item] : bulkOperation.ids.filter(optionItem => optionItem.id !== item.id)
					}
				});
			}
		} catch (error) {
			console.error("Error fetching data:", error);
		}
	}
	engineType = (data) => {
		this.setState({ basicDetails: data })
	}

	render() {
		const { tabIndex, applyingFilter, sort, sort_by, assetsDetail, pageLoader, uuid, slug, bulkOperation, basicDetails, archiveModal, isBasicDetailExpanded } = this.state;
		const { aircraftTypes, engineTypes, lessees } = this.props;
		let filterOptions = assetFilterOps;
		if (tabIndex === 0 || tabIndex === 1) {
			filterOptions = {
				...filterOptions,
				aircraft_type: {
					...filterOptions.aircraft_type,
					options: aircraftTypes,
				},
			};
			if (tabIndex === 1) {
				delete filterOptions.engine_type;
			}
		}
		if (tabIndex === 0 || tabIndex === 2) {
			filterOptions = {
				...filterOptions,
				engine_type: {
					...filterOptions.engine_type,
					options: engineTypes,
				},
			};
			if (tabIndex === 2) {
				delete filterOptions.aircraft_type;
			}
		}

		filterOptions = {
			...filterOptions,
			lessee: {
				...filterOptions.lessee,
				options: lessees,
			},
		};
		return (
			<section className="amp-listing-section">
				{pageLoader ? <PageLoader /> : null}
				<Grid className="mt-0" spacing={3} container>
					<Grid className="pr-0 pt-0" xs={12} item>
						<SubDetails
							masterExport={true}
							module="ad"
							title="Airworthiness Directives (ADs)"
							slug={slug}
							match={this.props?.match}
							props={this.props}
							onRefresh={this.refreshComp}
							permissionCheck={permissionCheckFnforCamo({ primaryKey: "ad_status", keyIndex: "U" })}
						/>
						<BasicDetailHeader props={this.props} func={this.pullData} uuid={this.uuidData} engineType={this.engineType} module='ad' onAccordionChange={(expanded) => this.setState({ isBasicDetailExpanded: expanded })} />
						{permissionCheckFnforCamo({
							primaryKey: "ad_status",
							keyIndex: "R",
						}) ? (
							<div className="custom-border">
								<AdSearchBar
									currentRecordPerPage={this.state.currentRecordPerPage}
									headerTsn={this.state.headerTsn}
									headerCsn={this.state.headerCsn}
									applyingFilter={applyingFilter}
									filterOptions={filterOptions}
									tabIndex={tabIndex}
									uuid={uuid}
									getResponseBack={this.refreshComp}
									pageLoader={"pageLoader"}
									props={this.props}
									slug={slug}
									basicDetails={basicDetails}
									importFile={this.importFile}
									fileUploadData={this.fileUploadData}
									searchData={(e) => this.searchResults(e.target.value)}
									exportReportFn={(file) => this.exportAssetDetailListFunc({ download: file.extension, ...{ ...convertFilterObject(removeEmptyKey(applyingFilter), filterOptions), asset_type: tabIndex, }, }, "pageLoader")}
								/>
								<AdTable
									currentRecordPerPage={this.state.currentRecordPerPage}
									// heads={smbcInstance ? smbceHead : AdTableHead}
									heads={this.props?.match?.params?.assetType === 1 || this.props?.match?.params?.assetType === "1" ? smbceHead.filter(item => item?.id !== "applicability") : smbceHead}
									sort={sort}
									assetType={this.props?.match?.params?.assetType === 1 || this.props?.match?.params?.assetType === "1"}
									basicDetails={basicDetails}
									sort_by={sort_by}
									isBasicDetailExpanded={isBasicDetailExpanded}
									bulkDeletefn={() => this.bulkDelete(this.props, bulkOperation, assetsDetail.pagination.per_page,)}
									bulkOperation={bulkOperation}
									bulkFlag={assetsDetail?.list?.length === bulkOperation?.ids?.length && assetsDetail?.list?.length > 0}
									toggleBulkOps={(flag) => this.toggleBulkOps(flag, 'bulk')}
									data={assetsDetail?.list?.map((item, index) => (
										<AdList
											bulkOperation={bulkOperation}
											toggleBulkOps={(flag) => this.toggleBulkOps(flag, 'single', item)}
											currentRecordPerPage={this.state.currentRecordPerPage}
											key={index}
											item={item}
											index={index}
											uuid={uuid}
											basicDetails={basicDetails}
											assetsDetail={assetsDetail}
											last_used_folder_uuid={assetsDetail.new_task_last_used_folder_uuid}
											last_used_folder_uuid_link_document={assetsDetail.last_used_folder_uuid_link_document}
											checkbox_last_used_folder_uuid={assetsDetail.checkbox_last_used_folder_uuid}
											checkbox_last_used_folder_name={assetsDetail.checkbox_last_used_folder_name}
											getResponseBack={this.refreshComp}
											headerTsn={this.state.headerTsn}
											headerCsn={this.state.headerCsn}
											handleDeleteRow={(data) =>
												this.handleDeleteRow(
													item,
													this.props,
													this.state.currentRecordPerPage
												)
											}
											updateFormData={this.updateFormData}
											handleEditRow={(data) =>
												this.handleEditRow(item, this.props)
											}
											props={this.props}
											fileUploadData={this.fileUploadData}
											downloadAllApi={(file) => this.downloadAllFilesApi({ download: file.extension, ...{ ...convertFilterObject(removeEmptyKey(applyingFilter), filterOptions), asset_type: tabIndex, item, }, }, "pageLoader")}
										/>
									))}
									createSortHandler={this.createSortHandler}
									pagination={assetsDetail.pagination}
									onChangePage={(event, newPage) => this.getAdDataApi({ ...convertFilterObject(removeEmptyKey({ ...applyingFilter, asset_type: this.state.tabIndex, per_page: assetsDetail.pagination.per_page, page: newPage + 1, }), filterOptions), }, "pageLoader", this.props)}
									onChangeRowsPerPage={(event) => this.setState({ currentRecordPerPage: event.target.value }, () => { this.getAdDataApi({ ...convertFilterObject(removeEmptyKey({ ...applyingFilter, asset_type: this.state.tabIndex, per_page: this.state.currentRecordPerPage, }), filterOptions), }, "pageLoader", this.props); })}
									noRecord={
										assetsDetail?.list?.length ? null : !this.state.pageLoader ? (
											<EmptyCollection title="No Records Found" />
										) : null
									}
								/>
							</div>
						) : (
							<AccessDenied />
						)}

					</Grid>
				</Grid>
				{
					archiveModal ?
						<DeletePopUp
							title='Archive Asset'
							deleteRecordFn={() => this.onArchiveAsset(this.props, slug)}
							modal={() => this.setState({ archiveModal: true })}
							content='Are you sure, you want to Archive?'
							toggleModalFn={() => this.setState({ archiveModal: false })}
							confirmText="ARCHIVE"
						/>
						: null
				}
			</section>
		);
	}
}
export default withSnackbar(ADComponent);
